import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const MyStorage00Table: GenericTableSchemaInterface = {
  id: "my-storage-00",
  name: "My Storage 00",
  description: "This table contains data regarding how many people engage with content in My Storage.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "CTA Messages"
    },
    c04: {
      name: "Tour"
    },
    c05: {
      name: "Key Access/Lock"
    },
    c06: {
      name: "Gate Code"
    },
    c07: {
      name: "After Hours Access"
    },
    c08: {
      name: "Pay Bill"
    },
    c09: {
      name: "Auto Pay"
    },
    c10: {
      name: "Change Due Date"
    },
    c11: {
      name: "Update Contact Info"
    },
    c12: {
      name: "Reset Password"
    },
    c13: {
      name: "Forgot Username"
    },
    c14: {
      name: "Update Billing Info"
    },
    c15: {
      name: "Create Login"
    },
    c16: {
      name: "Grace Period"
    },
    c17: {
      name: "Reservation"
    },
    c18: {
      name: "Cancel Service"
    },
    c19: {
      name: "Past Due"
    },
    c20: {
      name: "Hold Unit"
    },
    c21: {
      name: "Standard Ceiling Height"
    },
    c22: {
      name: "Climate Control"
    },
    c23: {
      name: "Security"
    },
    c24: {
      name: "Outdoor Parking"
    },
    c25: {
      name: "Drive Up Units"
    },
    c26: {
      name: "Maintenance Pest"
    },
    c27: {
      name: "Lights"
    },
    c28: {
      name: "Packing Supplies"
    },
    c29: {
      name: "Moving Truck"
    },
    c30: {
      name: "Moving Services"
    },
    c31: {
      name: "Dollies"
    },
    c32: {
      name: "Auctions"
    },
    c33: {
      name: "Auction Winners"
    },
    c34: {
      name: "Franchise"
    },
    c35: {
      name: "Wine Storage"
    },
    c36: {
      name: "Get Out"
    },
    c37: {
      name: "Billing Dispute"
    },
    c38: {
      name: "Emergency"
    },
    c39: {
      name: "Web Issue"
    },
    c40: {
      name: "Damaged Items"
    },
    c41: {
      name: "Theft"
    },
    c42: {
      name: "Lost Key"
    },
    c43: {
      name: "Pricing"
    },
    c44: {
      name: "Purchase Payment Options"
    },
    c45: {
      name: "Pay Online"
    },
    c46: {
      name: "Storable Items"
    },
    c47: {
      name: "Contract Lengths"
    },
    c48: {
      name: "Facility Access"
    },
    c49: {
      name: "Identification"
    },
    c50: {
      name: "Cancellation"
    },
    c51: {
      name: "Move Out Policy"
    },
    c52: {
      name: "Refunds"
    },
    c53: {
      name: "Prorate"
    },
    c54: {
      name: "Lease: Insurance"
    },
    c55: {
      name: "Claim"
    },
    c56: {
      name: "Covid"
    },
    c57: {
      name: "Cut Locks"
    },
    c58: {
      name: "Overlock"
    },
    c59: {
      name: "Live In Unit"
    },
    c60: {
      name: "Vehicle Storage Guidelines"
    },
    c61: {
      name: "Unit Transfer"
    },
    c62: {
      name: "Work In Unit"
    },
    c63: {
      name: "Admin Fee"
    },
    c64: {
      name: "Late Fee"
    },
    c65: {
      name: "Rate Increase"
    },
    c66: {
      name: "Web Rates"
    },
    c67: {
      name: "Insurance Cost"
    },
    c68: {
      name: "Credit Card Fee"
    },
    c69: {
      name: "Referral"
    },
    c70: {
      name: "Account Balance"
    },
    c71: {
      name: "Payment Issue"
    },
    c72: {
      name: "Payment Extension"
    },
    c73: {
      name: "Partial Payment"
    },
    c74: {
      name: "Payment History"
    },
    c75: {
      name: "Billing Dispute"
    }
  }
};
